<template>
    <div>
        <loading :show="showLoading"></loading>
        <paged-loading :is-loading="loadingImg" @pagechange="onPageChange" :paging-info="paging">
            <div>
                <div>
                    <form method="POST" enctype="multipart/form-data" ref="fileForm">
                        <div class="input-group">
                            <span class="input-group-btn">
                                <span class="btn btn-primary" @click="uploadFile">Submit</span>
                            </span>
                            <input type="file" name="files" multiple class="form-control" />

                        </div>
                    </form>
                </div>
            </div>

            <div class="row" style="margin-left:0;margin-right:0;">
                <div v-for="file in newFileList" :key="file.fileID" class="col-xs-6 col-md-3 col-sm-4"
                    style="height:200px;text-align:center;overflow:hidden;border-bottom: 1px solid gray;">
                    <div style="display: flex;flex-direction: column;height: 100%;padding:4px;">
                        <div>
                            <img class="img-responsive" :src="file.thumbPath"
                                style="display:inline-block;max-height:140px;">
                        </div>
                        <div style="margin-top: auto;">
                            <div>{{ file.fileType }}</div>
                            <span class="btn btn-default" @click="onSelect(file)">Select</span>
                        </div>
                    </div>
                </div>
            </div>

            <hr />
            <div>
                <div v-for="file in fileList" :key="file.fileID" class="col-xs-6 col-md-3 col-sm-4"
                    style="height:200px;text-align:center;overflow:hidden;border-bottom: 1px solid gray;">
                    <div style="display: flex;flex-direction: column;height: 100%;padding:4px;">
                        <div>
                            <img class="img-responsive" :src="file.thumbPath"
                                style="display:inline-block;max-height:140px;">
                        </div>
                        <div style="margin-top: auto;">
                            <div>{{ file.fileType }}</div>
                            <span class="btn btn-default" @click="onSelect(file)">Select</span>
                        </div>
                    </div>
                </div>
            </div>
        </paged-loading>
    </div>
</template>
<script>
import pagedLoading from '../components/base/PagedLoading.vue';
import queryString from '../utl/queryString';
import apis from '../api/extApi.js';
import loading from '../components/base/Loading.vue';

export default {
    components: {
        pagedLoading: pagedLoading,
        loading: loading
    },
    props: {
        "userId": String,
        "processing": { type: Boolean, default: false }
    },
    computed: {
        showLoading: function () {
            return this.isLoading || this.processing;
        }
    },
    data: function () {
        return {
            apiClient: apis.api,
            fileList: [],
            newFileList: [],
            paging: { page: 1, pageSize: 1, count: 1 },
            loadingImg: false,
            isLoading: false
        };
    },
    methods: {
        uploadFile: function () {
            var data = new FormData(this.$refs.fileForm);
            this.isLoading = true;
            this.apiClient.uploadFilePrms(this.userId, data).done((ret) => {
                this.isLoading = false;
                this.newFileList.push(...ret.value);
            });
        },
        onPageChange: function (newPage) {
            var obj = { page: newPage, uid: this.userId };
            this.loadItems(queryString().getString(obj));
        },
        onSelect: function (file) {
            this.$emit('onselect', file);
        },
        loadItems: function (query) {
            var that = this;
            this.loadingImg = true;
            this.apiClient.getUserFilesPrms(query).done(function (ret) {
                that.loadingImg = false;
                var filter = ret.value.filter;
                that.paging = { page: filter.page, pageSize: filter.pageSize, count: filter.count };
                that.fileList = ret.value.items;
            });
        }
    },
    created: function () {
        var obj = { uid: this.userId };
        this.loadItems(queryString().getString(obj));
    },
    mounted: function () {

    }
}
</script>